import ChallengeCreateEditForm from './ChallengeCreateEditForm';

export default ChallengeCreateEditForm;
